import { useEffect, useRef } from 'react';
import type { MultiProductBookingState } from '@src/stores/multiProductBooking';
import { trackUpsellBookingStarted } from '../../analytics/upsellTracking';

interface UseUpsellBookingEventTrackParams {
  booking: MultiProductBookingState | undefined;
  selectedProductId: string | undefined;
}

export const useUpsellBookingEventTrack = ({ booking, selectedProductId }: UseUpsellBookingEventTrackParams) => {
  const trackedProductIdsRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    if (!booking || !selectedProductId) return;
    if (trackedProductIdsRef.current.has(selectedProductId)) return;

    trackedProductIdsRef.current.add(selectedProductId);
    const sequenceIndex = booking.productIds.indexOf(selectedProductId);
    trackUpsellBookingStarted(booking.sourceProductId, selectedProductId, sequenceIndex);
  }, [booking, selectedProductId]);
};
